"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPreservationInfo = void 0;
const FlowConfig_1 = __importDefault(require("@/class/FlowConfig"));
const utils_1 = require("@/config/utils");
const router_1 = __importDefault(require("@/pages/index/router"));
const preservationFlowConfig = new FlowConfig_1.default({
    list: [
        'ufo_cs_bq_10',
        'ufo_cs_bq_20',
        'ufo_cs_bq_30',
        // 'ufo_cs_bq_40', // 法务专员 // 无
        'ufo_cs_bq_50',
        // 'ufo_cs_bq_60', // 运营内勤
        // 'ufo_cs_bq_70', // 财务
        'ufo_cs_bq_80', // 结束？
    ]
});
const toPreservationInfo = function (preservationId, overdueRecordOrFlowId, flowKey) {
    if (flowKey === 'start') {
        flowKey = preservationFlowConfig.getBuild();
    }
    else if (flowKey === 'end') {
        flowKey = preservationFlowConfig.getEnd();
    }
    router_1.default.push(`/external/preservation/info/${preservationId}/${(0, utils_1.simpleEncrypt)(overdueRecordOrFlowId)}/${(0, utils_1.simpleEncrypt)(flowKey)}`);
};
exports.toPreservationInfo = toPreservationInfo;
exports.default = preservationFlowConfig;
